import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TaStepsService } from '../ta-steps.service';

@Component({
  selector: 'app-ta-steps-view',
  templateUrl: './ta-steps-view.component.html',
  styleUrls: ['./ta-steps-view.component.css']
})
export class TaStepsViewComponent implements OnInit {
  parent_id: number;
  id: number;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public service: TaStepsService
  ) {}

  ngOnInit() {
    this.parent_id = Number(this.route.snapshot.params['ta_id']);
    this.id = Number(this.route.snapshot.params['step_id']);

    if (this.id) {
      this.service.get(this.parent_id, this.id, false, () => {
      });
    } else {
      this.router.navigate(['task-analyses', this.parent_id, 'steps']);
    }
  }
}
